import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-500">
      <Link to="/" className="cursor-pointer transition-colors hover:text-primary-600">
        首页
      </Link>
      {items.map((item) => (
        <span key={`${item.label}-${item.to ?? "current"}`} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-300"></i>
          {item.to ? (
            <Link to={item.to} className="cursor-pointer transition-colors hover:text-primary-600">
              {item.label}
            </Link>
          ) : (
            <span className="max-w-[240px] truncate text-foreground-700">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}